<template>
  <v-btn
  v-if="!confirm"
  :loading="loading"
  @click="confirm = true"
  :disabled="disabled"
  :elevation="1"
  :height="height"
  :width="width"
  text
  icon>
    <mdi-icon
    src="delete-forever"
    color="#ff3547"/>
  </v-btn>
  <v-btn
  v-else
  :loading="loading"
  @mouseleave="confirm = false"
  @click="$emit('click')"
  :disabled="disabled"
  :elevation="10"
  :height="height"
  :width="width"
  icon>
    <mdi-icon
    src="alert-circle"
    color="#ff3547"/>
  </v-btn>
</template>
<script>
import MdiIcon from '@/components/btns/MdiIcon'
export default {
  components: {
    MdiIcon
  },
  props: {
    loading: Boolean,
    height: Number,
    width: Number,
    disabled: Boolean
  },
  data: () => {
    return {
      confirm: false
    }
  }
}
</script>
<style>

</style>